var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventActionActuator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0Z",
    fill: "#424F69"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4767:49264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.95 12.1001C10.4337 12.1001 9.2 10.8665 9.2 9.35015C9.2 7.83378 10.4337 6.6001 11.95 6.6001C13.4664 6.6001 14.7 7.83378 14.7 9.35015C14.7 10.8665 13.4664 12.1001 11.95 12.1001ZM11.95 7.4251C10.8885 7.4251 10.025 8.28858 10.025 9.35015C10.025 10.4116 10.8885 11.2751 11.95 11.2751C13.0115 11.2751 13.875 10.4116 13.875 9.35015C13.875 8.28858 13.0115 7.4251 11.95 7.4251Z",
    fill: "#00CBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0501 27.5C19.5337 27.5 18.3 26.2664 18.3 24.7501C18.3 23.2337 19.5337 22 21.0501 22C22.5664 22 23.8 23.2337 23.8 24.7501C23.8 26.2664 22.5664 27.5 21.0501 27.5ZM21.0501 22.825C19.9885 22.825 19.125 23.6885 19.125 24.7501C19.125 25.8115 19.9885 26.675 21.0501 26.675C22.1115 26.675 22.975 25.8115 22.975 24.7501C22.975 23.6885 22.1115 22.825 21.0501 22.825Z",
    fill: "#00CBAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14H19.5C20.3284 14 21 14.6716 21 15.5V20H13.5C12.6716 20 12 19.3284 12 18.5V14Z",
    stroke: "#00CBAF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 12,
    stroke: "#00CBAF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 22.4,
    x2: 21,
    y2: 19.4,
    stroke: "#00CBAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4767:49264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventActionActuator);
export default __webpack_public_path__ + "static/media/event-action-actuator.55dee475b615154b6a69d39b6dc5a55b.svg";
export { ForwardRef as ReactComponent };